// extracted by mini-css-extract-plugin
export var inline = "_wb-0";